export const PRICE_EXCESS_BOUNDS = {
  upper: 1.1,
  lower: 0.9,
};
